<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <div class="profile-text">
          <h4 class="text-left">{{ $t('project.descriptionLanguage') }}:</h4>
          <div class="row select-language-buttons" v-if="project.translations">
            <div v-for="language in project.translations" class="col-lg-4 col-xs-6">
              <button
                :value="language.locale"
                type="button"
                class="select-language-btn sm text-center"
                :class="[{ crowd: project.crowdfunding, raise: !project.crowdfunding, active: language.locale === locale}]"
                @click="changeLanguage(language.locale)">
                {{ $t(`language.${language.locale}`) }}
              </button>
            </div>
          </div>
          <h4 class="text-left">{{ $t('project.form.shortDescription') }}</h4>
          <textarea v-model="project.translation.description"
            :disabled="!isEditable"
            class="form-control my-short-desc"
            rows="7" maxlength="150"
            :placeholder="$t('project.form.shortDescriptionPlaceholder')">
          </textarea>
        </div><!-- .profile-text -->
      </div><!-- .col-md-3 -->
      <fieldset :disabled="!isEditable">
        <div class="col-md-8">
          <div class="profile-photo">
            <div v-if="project.id">
              <div v-if="image">
                <img :src="image"/>
                <button v-if="newImage" @click.prevent="removeImage" :class="'btn btn-default btn-lg mb-0 button-wide-' + crowd_or_rais">{{ $t('cancel') }}</button>
              </div>
              <div v-else-if="project.photo.url">
                <img :src="$server_url + project.photo.url + '?cachingPrevent' + Math.random()" />
              </div>
              <img v-else src="~assets/img/do-more-img-4-3.gif">
            </div>
            <div v-else>
              <div v-if="image">
                <img :src="image"/>
                <button v-if="newImage" @click.prevent="removeImage" :class="'btn btn-default btn-lg mb-0 button-wide-' + crowd_or_rais">{{ $t('cancel') }}</button>
              </div>
              <div v-else-if="project.photo.url">
                <img :src="$server_url + project.photo.url" />
              </div>
              <img v-else src="~assets/img/do-more-img-4-3.gif">
            </div>
          </div><!-- .profile-photo -->
        </div><!-- .col-md-6 -->
        <div class="col-md-4">
          <div class="profile-right">
            <h3>{{ $t("project.form.campaignPhoto") }}</h3>
            <p>{{ $t("project.form.campaignPhotoDescription") }}</p>
            <button  type="button" @click="$refs.file_input.$refs.input.click()" :class="'btn btn-default btn-lg mb-0 button-wide-' + crowd_or_rais">
              <span v-if="project.photo">{{ $t("project.form.updatePhotoButton") }}</span>
              <span v-else>{{ $t("project.form.addPhotoButton") }}</span>
            </button>
            <upload-base64 :multiple="false" :done="getFiles" ref="file_input"></upload-base64>
            <div v-if="sizeError" class="has-error">
              <p class="help-block pt-5 mb-0">{{ $t("profile.edit.photoSizeError") }}</p>
            </div>
            <h3>{{ $t("project.form.campaignVideo") }}</h3>
            <p>{{ $t("project.form.campaignVideoContent") }}</p>
            <form-error :errors="videoUrlError" :attribute="'video_url'" class="position-relative">
              <input v-model="videoInput" class="form-control pr-20" :placeholder="$t('project.form.campaignVideoDescription')" @input="checkIfEmpty">
              <div v-if="videoInput.length" @click="deleteVideo" :class="'clear-input-' + crowd_or_rais" >&#215;</div>
            </form-error>
            <button @click="addVideo" type="button" :class="'btn btn-default btn-lg mb-0 button-wide-' + crowd_or_rais">{{ $t("project.form.addVideoButton") }}</button>
            <button v-show="project.video_url" @click="deleteVideo" type="button" :class="'btn btn-default btn-lg mb-0 button-wide-' + crowd_or_rais">{{ $t("project.form.removeVideoButton") }}</button>
          </div><!-- .profile-right -->
        </div><!-- .col-md-3 -->
      </fieldset>
    </div><!-- .row -->
    <div v-if="project.video_url" class="row mt-30">
      <div class="col-md-12">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe ref="videoRef" :src="project.video_url.replace('watch?v=', 'embed/')" id="video-container" controls></iframe>
        </div>
      </div>
    </div>
    <div class="row mt-30" style="min-height: 300px">
      <div class="col-md-9">
        <h4 class="mb-20">{{ $t("project.form.longDescriptionTitle") }}</h4>
        <trumbowyg
          :content="project.translation.story"
          @tbwblur="setStory"
          :placeholder="$t('project.form.longDescription')"
          :disabled="!isEditable"
          ref="trumbowyg">
        </trumbowyg>
        <button v-if="project.translations.length < languages.length"
          @click="addTranslationModalVisible = true"
          :disabled="!isEditable"
          type="button"
          :class="'btn btn-default btn-lg uppercase button-wide-' + crowd_or_rais">
          <span v-if="!submit.processing">{{ $t('project.form.addTranslation') }}</span>
          <clip-loader :loading="submit.processing" :color="'#fff'"></clip-loader>
        </button>
        <!-- Modal -->
        <transition name="modal">
          <modal v-if="addTranslationModalVisible" :close="() => { addTranslationModalVisible = false }">
            <h3 slot="header">Select language</h3>
            <div slot="body" class="row">
              <div class="col-xs-12">
                <div v-for="language in languages" v-if="!translationExists(language.locale)" class="col-lg-3 col-xs-4">
                  <button
                    @click="addTranslation(language)"
                    type="button"
                    class="select-language-btn text-center">
                    {{ $t(`language.${language.locale}`) }}
                  </button>
                </div>
              </div>
            </div>
            <div slot="footer" style="display: inline"></div>
          </modal>
        </transition>
        <p v-if="project.id">
          <b>{{ $t('project.form.addNextTranslationInfo') }}</b>
        </p>
      </div><!-- .col-md-9 -->
      <!-- Socials -->
      <div class="col-md-3" style="margin:auto;margin-top:0">
        <div class="all-categories mb-20" style="margin-top:0">
          <strong>{{ $t("profile.edit.outsideLinks") }}</strong>
        </div>
        <fieldset :disabled="!isEditable">
          <input v-model="project.facebook" class="form-control mb-20" placeholder="Facebook Link">
          <input v-model="project.twitter" class="form-control mb-20" placeholder="Twitter Link">
          <input v-model="project.youtube" class="form-control mb-20" placeholder="YouTube Link">
          <input v-model="project.google" class="form-control mb-20" placeholder="Google Plus Link">
          <input v-model="project.custom_link" class="form-control mb-20" placeholder="Your website link">
        </fieldset>
      </div><!-- .col-md-3 -->
      <!-- Socials -->
    </div>
    <button v-if='showSaveButton() && isEditable' @click="saveProject" :disabled="submit.processing" type="button" :class="'btn btn-default btn-lg uppercase button-wide-' + crowd_or_rais">
      <span v-if="!submit.processing">{{ $t("save") }}</span>
      <clip-loader :loading="submit.processing" :color="'#fff'"></clip-loader>
    </button>
    <!-- Go to next step if project is saved -->
    <button v-if='!showSaveButton()' @click="editProject(redirectToEdit)" type="button" :class="'btn btn-default btn-lg button-wide-' + crowd_or_rais">{{ $t('next') }}</button>
    <alert :success="alert.success" :error="alert.error"></alert>
  </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';
import UploadBase64 from '@/components/UploadBase64';
import Alert from '@/components/Alert';
import FormError from '@/components/FormError';
import Trumbowyg from '@/components/Trumbowyg';
import Modal from '@/components/Modal';
import LightKYC from '@/components/Profile/LightKYC';

import projectModel from '@/models/project';
import projectsApi from '@/api/v1/projects';

export default {
  components: { Alert, UploadBase64, Trumbowyg, ClipLoader, FormError, Modal, LightKYC },
  props: {
    project: {
      type: Object,
      default: projectModel.project,
    },
    alert: Object,
    submit: {
      action: Function,
      processing: Boolean,
    },
  },
  data() {
    return {
      image: '',
      newImage: false,
      languages: projectsApi.languages(),
      locale: localStorage.getItem('lang'),
      videoUrlError: {},
      sizeError: false,
      videoInput: '',
      updateVideo: false,
      addTranslationModalVisible: false,
    };
  },
  methods: {
    addVideo() {
      const url = this.videoInput;
      if (
        url
          .toLowerCase()
          .match('http(?:s?)://(?:www.)?(vimeo | youtu(?:be.com/embed))?')
      ) {
        this.project.video_url = url;
        this.videoUrlError = {};
        this.updateVideo = true;
      } else {
        this.videoUrlError = {
          video_url: [this.$t('project.form.campaignVideoUrlError')],
        };
      }
    },
    deleteVideo() {
      this.project.video_url = '';
      this.videoInput = '';
    },
    setStory(content) {
      this.project.translation.story = content;
    },
    removeImage() {
      this.image = '';
    },
    showSaveButton() {
      return !this.project.id || this.$route.params.id;
    },
    getFiles(files) {
      const maxWidth = 720;
      const maxHeight = 540;
      if (files.width !== maxWidth || files.height !== maxHeight) {
        this.sizeError = true;
      } else {
        this.sizeError = false;
        this.image = files.base64;
        this.newImage = true;
      }
    },
    redirectToEdit() {
      const routerName = this.project.crowdfunding
        ? 'edit_crowdfunding'
        : 'edit_fundraising';
      this.$router.push({
        name: routerName,
        params: { id: this.project.id },
        query: { tab: 'reward' },
      });
    },
    editProject(onSuccess = () => {}) {
      this.submit.processing = true;
      this.project.photo = this.image;
      this.newImage = false;
      projectsApi.edit(this.project).then(() => {
        this.submit.processing = false;
        this.alert.success = this.$t('project.form.changesSaved');
        onSuccess();
      })
      .catch((response) => {
        this.submit.processing = false;
        this.alert.error = this.$t('errors.incorrectData');
        const errors = response.response.data;
        this.errors = errors;
        window.scrollTo(0, 0);
      });
    },
    changeLanguage(locale) {
      const vm = this;
      if (vm.project.translations) {
        vm.project.translations.forEach((translation) => {
          if (translation.locale === locale) {
            vm.project.translation = translation;
            this.setTrumbowygContent(translation.story);
          }
        });
      }
      vm.project.translation.locale = locale;
      vm.locale = locale;
    },
    translationExists(locale) {
      if (!this.project.translations) return false;
      return this.project.translations.find(translation => translation.locale === locale);
    },
    saveProject() {
      this.project.photo = this.image;
      this.newImage = false;
      this.submit.action();
    },
    checkIfEmpty() {
      if (this.videoInput === '') {
        this.deleteVideo();
      }
    },
    addTranslation(language) {
      // this.editProject(); // TODO auto-save after adding new translation is not working as expected
      const translation = {
        locale: language.locale,
        description: '',
        story: '',
      };
      this.project.translation = translation;
      this.project.translations.push(translation);
      this.locale = language.locale;

      this.addTranslationModalVisible = false;
      this.setTrumbowygContent('');
    },
    getActiveTranslation() {
      const locale = this.locale;
      return this.project.translations.find(
        translation => translation.locale === locale,
      );
    },
    setTrumbowygContent(content) {
      this.$refs.trumbowyg.setContent(content);
    },
  },
  computed: {
    crowd_or_rais() {
      return this.project.crowdfunding ? 'crowd' : 'rais';
    },
    isEditable() {
      return !this.project.status || this.project.status === 'created';
    },
  },
  created() {
    this.project.translation = this.getActiveTranslation();
    if (!this.translationExists(this.locale)) {
      this.changeLanguage(this.project.translations[0].locale);
    }
  },
  watch: {
    project() {
      if (this.project.video_url) {
        this.updateVideo = true;
        this.videoInput = this.project.video_url;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Details.vue?dffb3502